import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import ConfiguratorPage from "@/pages/ConfiguratorPage";
import ExteriorCollectionPage from "@/pages/ExteriorCollectionPage";
import InteriorCollectionPage from "@/pages/InteriorCollectionPage";
import GarageCollectionPage from "@/pages/GarageCollectionPage";
import ProfessionalPage from "@/pages/ProfessionalPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider } from "@/context/AuthContext";
import { QuoteProvider } from "@/context/QuoteContext";
import FloatingCartButton from "@/components/FloatingCartButton";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import CustomCursor from "@/components/CustomCursor";
import PixelTracker from "@/components/PixelTracker";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <PixelTracker />
          <QuoteProvider>
            <SmoothScroll>
              <CustomCursor />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/collection/exterior" element={<ExteriorCollectionPage />} />
                <Route path="/collection/interior" element={<InteriorCollectionPage />} />
                <Route path="/collection/garage" element={<GarageCollectionPage />} />
                <Route path="/professional" element={<ProfessionalPage />} />
                <Route path="/pro-pricing" element={<ProfessionalPage />} />
                <Route path="/configurator" element={<ConfiguratorPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/*" element={<AdminDashboard />} />
              </Routes>
              <FloatingCartButton />
            </SmoothScroll>
          </QuoteProvider>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0E2E28",
                color: "#F5EFE6",
                border: "1px solid rgba(195,154,90,0.35)",
                fontFamily: "Manrope, sans-serif",
                letterSpacing: "0.05em",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
